// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"infosBox-module--infoBox--1lxW-","line":"infosBox-module--line--FsYip"};